import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'zigzagSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('zigzagSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('zigzagSVG_hover');
  };

  return (
    <svg
      version="1.1"
      viewBox="0 0 459.9 140.1"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
    >
      <polygon
        points="18,83.8 66,42.9 113.7,83.8 161.8,42.9 209.8,83.8 258.6,42.9 305.9,83.8 354,42.9 401.7,83.8 401.7,97.7 354,56.4 
  305.9,97.7 258.6,56.4 209.8,97.7 161.8,56.4 113.7,97.7 66,56.4 18,97.7 "
        ref={hoverRef}
      />
    </svg>
  );
};

export default SVG;
